import { ArrowIcon } from "../../assets/icons"
import { addMonths } from "../../utils/addMonths";
import { CalendarDay } from "./calendarDay";

import styles from "./calendar.module.css";

import { Text } from "../text/text";

const weekDays = ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ", "ВС"];

export const Calendar = ({ date, setDate, shifts = [], onClick = () => { }, shiftType = () => "shift", selectedDates = [] }) => {
    const year = date.getFullYear();
    const month = date.getMonth();

    const shiftDate = new Date(date);
    const monthName = shiftDate.toLocaleString('ru-RU', { month: 'long' });

    const prevMonth = [];
    const lastDayOfPrevMonth = new Date(year, month, 0).getDate();
    const weekIdOfFirstDay = new Date(year, month, 1).getDay();
    const cntOfPrevDayz = weekIdOfFirstDay || 7;

    for (let i = 0; i < cntOfPrevDayz - 1; i++) {
        prevMonth.push(lastDayOfPrevMonth - i);
    }

    const curMonth = []
    const cnt_of_days = 32 - new Date(year, month, 32).getDate();
    for (let i = 1; i <= cnt_of_days; i++) {
        curMonth.push(i)
    }

    const nextMonth = [];
    for (let i = 0; i < (7 - (cnt_of_days + cntOfPrevDayz - 1) % 7) % 7; i++) {
        nextMonth.push(i + 1)
    }

    prevMonth.reverse()

    const handlePrevMonth = () => {
        setDate(addMonths(date, -1));
    }

    const handleNextMonth = () => {
        setDate(addMonths(date, 1));
    }

    return (
        <div className={styles.calendar}>
            <div className={styles.calendar_header}>
                <ArrowIcon className={styles.calendar_arrow} angle={180} onClick={handlePrevMonth} />
                <Text as="div" variant="h3" className={styles.month_name} >{monthName} {year}</Text>
                <ArrowIcon className={styles.calendar_arrow} onClick={handleNextMonth} />
            </div>
            <div className={styles.calendar_data}>
                {
                    weekDays.map((day, i) =>
                        <Text as="div" variant="body" className={styles.calendar_week_day}  key={i}>{day}</Text>
                    )
                }

                {
                    prevMonth.map((day, i) =>
                        <CalendarDay key={i} date={new Date(year, month - 1, day)} type="secondary" />
                    )
                }

                {
                    curMonth.map((day, i) => {
                        const date = new Date(year, month, day, 12)
                        const curShift = shifts.find(a => a.shiftDate === date.toISOString().split('T')[0]);
                        const isSelected = selectedDates.some(d => d.getTime() === date.getTime());
                        return <CalendarDay key={i} date={date} type={isSelected ? "info" : shiftType(curShift)} onClick={() => onClick(date, curShift)} />
                    })
                }

                {
                    nextMonth.map((day, i) =>
                        <CalendarDay key={i} date={new Date(year, month + 1, day)} type="secondary" />
                    )
                }
            </div>
        </div>
    )
}
